import { actions } from "../../utils/constants"

export const LoadingAction = (value) => {
    return { type: actions.SET_LOADING, value: value }
}